// import { useQuery } from '@tanstack/react-query';
// import { packageServices } from '../services/package.service';

// export const usePackages = ({
//   page,
//   limit,
//   sellerId,
//   isActive,
//   isPopular,
//   isFeatured,
//   search,
//   sortBy,
//   sortOrder,
// }) => {
//   return useQuery({
//     queryKey: ['packages', { page, limit, sellerId, isActive, isPopular, isFeatured, search, sortBy, sortOrder }],
//     queryFn: () =>
//       packageServices.getPackages({
//         page,
//         limit,
//         sellerId,
//         isActive,
//         isPopular,
//         isFeatured,
//         search,
//         sortBy,
//         sortOrder,
//       }),
//     staleTime: 5 * 60 * 1000, // 5 minutes
//     gcTime: 10 * 60 * 1000, // 10 minutes
//     keepPreviousData: true,
//   });
// };


import { useQuery } from '@tanstack/react-query';
import { packageServices } from '../services/package.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Get all packages
 */
export const usePackages = ({
  page,
  limit,
  sellerId,
  isActive,
  isPopular,
  isFeatured,
  search,
  sortBy,
  sortOrder,
  type
}) => {
  return useQuery({
    queryKey: [
      'packages',
      {
        page,
        limit,
        sellerId,
        isActive,
        isPopular,
        isFeatured,
        search,
        sortBy,
        sortOrder,
        type
      },
    ],

    queryFn: async () => {
      try {
        return await packageServices.getPackages({
          page,
          limit,
          sellerId,
          isActive,
          isPopular,
          isFeatured,
          search,
          sortBy,
          sortOrder,
          type
        });
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes

    placeholderData: (previousData) => previousData,

    retry: 1,
  });
};